import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors[props.type].surface};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors[props.type].default};
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
